
import React from 'react';
import { Ticket, AppSettings, RepairStageStatus } from '../types';

interface PrintableCompletionAgreementProps {
  ticket: Ticket;
  appSettings: AppSettings;
}

export const PrintableCompletionAgreement: React.FC<PrintableCompletionAgreementProps> = ({ ticket, appSettings }) => {
  if (!ticket || !appSettings) return null;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  };

  const completedServices = ticket.repairProgress
    .filter(stage => stage.status === RepairStageStatus.COMPLETED && stage.id !== 'received' && stage.id !== 'completed_paid')
    .map(stage => stage.name)
    .join(', ');
    
  const servicesSummary = completedServices || ticket.subject;


  return (
    <div className="p-4 font-sans text-xs leading-normal bg-white text-black">
      {appSettings.logoBase64 && (
        <div className="text-center mb-4">
          <img 
            src={appSettings.logoBase64} 
            alt={`${appSettings.companyName} Logo`} 
            className="mx-auto h-16 max-h-20 object-contain" 
          />
        </div>
      )}
      <h1 className="text-lg font-bold text-center mb-1">{appSettings.companyName}</h1>
      <h2 className="text-md font-semibold text-center mb-4">Service Completion Agreement</h2>

      <div className="grid grid-cols-2 gap-x-4 mb-4 text-xs">
        <div><strong>Ticket ID:</strong> {ticket.id}</div>
        <div><strong>Completion Date:</strong> {formatDate(ticket.updatedAt)}</div>
        <div><strong>Customer Name:</strong> {ticket.customer}</div>
        {ticket.customerPhoneNumber && <div><strong>Phone:</strong> {ticket.customerPhoneNumber}</div>}
        <div className="col-span-2"><strong>Device Model:</strong> {ticket.deviceModel || 'N/A'}</div>
        <div className="col-span-2">
            <strong>Service(s) Performed:</strong> {servicesSummary}
        </div>
        <div className="col-span-2">
            <strong>Final Amount Paid:</strong> ${ticket.amountDue.toFixed(2)} ({ticket.paymentStatus})
        </div>
      </div>
      
      <div className="mb-4 p-3 border border-slate-300 rounded-md bg-slate-50 text-xs">
        <h3 className="font-semibold mb-1">Terms and Conditions:</h3>
        <p className="whitespace-pre-wrap">{appSettings.completionAgreementText}</p>
      </div>

      <div className="mt-8 space-y-6 text-xs">
        <div className="flex justify-between items-end">
          <div className="w-2/5">
            <hr className="border-black mb-1" />
            <p>Customer Signature</p>
          </div>
          <div className="w-1/4">
            <hr className="border-black mb-1" />
            <p>Date</p>
          </div>
        </div>
         <div className="flex justify-start items-end pt-4">
            <div className="w-2/5">
                <hr className="border-black mb-1" />
                <p>{appSettings.companyName} Representative</p>
            </div>
        </div>
      </div>

      <p className="text-center text-[8pt] mt-6 text-slate-500">
        Thank you for your business!
      </p>
    </div>
  );
};
